import { openNotification } from "../../globals/Components/Notification/Notificaction";
import validateMessages from "../../globals/Inputs/validateMessages";
import { loginCookie, removeloginCookie, setAllUserInfo, setUserInfo } from "../../services/auth";
import { serverMessages, serverMessagesLogin } from "../serverMessages";
import { setMessageResponse, toggleLoadingIndicator } from "../system/actions";
import { MessageResponse } from "../system/types";
import { AppThunk } from "../thunks";
import { postSendEmailSolicitudBusinessProjectAPI } from "./restCallMessages";

export const postSendEmailSolicitudBusinessProject = (value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    debugger
    const responseData = await postSendEmailSolicitudBusinessProjectAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response
    }
    dispatch(toggleLoadingIndicator(false));
};